export default __webpack_public_path__ + "static/learn-more-ebc0a5d470de10cd9de21763572d795b.png";